import React from "react";
import { Table } from "semantic-ui-react";

export const vehicleDppaContent = (
  <div>
    <div id="top">
      <h3>MVR Availability</h3>
      <h4>Click on a search type to view coverage</h4>

      <ul>
        <li>
          <a href="#byPlate" className="mvrHref">
            By Plate
          </a>
        </li>
        <li>
          <a href="#byOwner" className="mvrHref">
            By Owner
          </a>
        </li>
        <li>
          <a href="#byAddress" className="mvrHref">
            By Address
          </a>
        </li>
        <li>
          <a href="#byVIN" className="mvrHref">
            By VIN
          </a>
        </li>
      </ul>
    </div>

    <Table>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <Table>
              <Table.Body>
                <Table.Row>
                  <Table.HeaderCell
                    colSpan={2}
                    className={"coverage-table-header"}
                  >
                    MVR Availability
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    State
                  </Table.HeaderCell>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    Last Update
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alaska</Table.Cell>
                  <Table.Cell>2004</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alabama</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Colorado</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Connecticut</Table.Cell>
                  <Table.Cell>2011</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>District of Columbia</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Delaware</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Florida</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Idaho</Table.Cell>
                  <Table.Cell>2004</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Illinois</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Kentucky</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Louisiana</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Massachusetts</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maryland</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maine</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Michigan</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Minnesota</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Missouri</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Mississippi</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Montana</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Carolina</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Dakota</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nebraska</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New Mexico</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nevada</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New York</Table.Cell>
                  <Table.Cell>2011</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Ohio</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Oklahoma</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>South Carolina</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Tennessee</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Texas</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Utah</Table.Cell>
                  <Table.Cell>2004</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wisconsin</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wyoming</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Table.Cell>
          <Table.Cell />
          <Table.Cell>
            <Table>
              <Table.Body>
                <Table.Row>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    MVR (DPPA)- Available States
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    By Plate
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alabama</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alaska</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Colorado</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Connecticut</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Delaware</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>DC</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Florida</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Idaho</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Illinois</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Kentucky</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Louisiana</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maine</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maryland</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Massachusetts</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Michigan</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Minnesota</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Mississippi</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Missouri</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Montana</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nebraska</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nevada</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New Mexico</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New York</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Carolina</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Dakota</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Ohio</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Oklahoma</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>South Carolina</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>South Dakota</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Tennessee</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Texas</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Utah</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wisconsin</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wyoming</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
    <br />
    <br />
    <a className="mvrHref" href="#top">
      Back To Top
    </a>
    <Table>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <Table>
              <Table.Body>
                <Table.Row>
                  <Table.HeaderCell
                    colSpan={2}
                    className={"coverage-table-header"}
                  >
                    MVR Availability
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    State
                  </Table.HeaderCell>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    Last Update
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alaska</Table.Cell>
                  <Table.Cell>2004</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alabama</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Colorado</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Connecticut</Table.Cell>
                  <Table.Cell>2011</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>District of Columbia</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Delaware</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Florida</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Idaho</Table.Cell>
                  <Table.Cell>2004</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Illinois</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Kentucky</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Louisiana</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Massachusetts</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maryland</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maine</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Michigan</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Minnesota</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Missouri</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Mississippi</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Montana</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Carolina</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Dakota</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nebraska</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New Mexico</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nevada</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New York</Table.Cell>
                  <Table.Cell>2011</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Ohio</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Oklahoma</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>South Carolina</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Tennessee</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Texas</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Utah</Table.Cell>
                  <Table.Cell>2004</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wisconsin</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wyoming</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Table.Cell>
          <Table.Cell />
          <Table.Cell>
            <Table>
              <Table.Body>
                <Table.Row>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    MVR (DPPA)- Available States
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    By Owner
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alabama</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alaska</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Colorado</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Connecticut</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Delaware</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>DC</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Florida</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Idaho</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Illinois</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Kentucky</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Louisiana</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maine</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maryland</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Massachusetts</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Michigan</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Minnesota</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Mississippi</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Missouri</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Montana</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nebraska</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nevada</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New Mexico</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New York</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Carolina</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Dakota</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Ohio</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Oklahoma</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>South Carolina</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>South Dakota</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Tennessee</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Texas</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Utah</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wisconsin</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wyoming</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
    <br />
    <br />
    <a className="mvrHref" href="#top">
      Back To Top
    </a>
    <Table>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <Table>
              <Table.Body>
                <Table.Row>
                  <Table.HeaderCell
                    colSpan={2}
                    className={"coverage-table-header"}
                  >
                    MVR Availability
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    State
                  </Table.HeaderCell>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    Last Update
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alaska</Table.Cell>
                  <Table.Cell>2004</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alabama</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Colorado</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Connecticut</Table.Cell>
                  <Table.Cell>2011</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>District of Columbia</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Delaware</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Florida</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Idaho</Table.Cell>
                  <Table.Cell>2004</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Illinois</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Kentucky</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Louisiana</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Massachusetts</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maryland</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maine</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Michigan</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Minnesota</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Missouri</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Mississippi</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Montana</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Carolina</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Dakota</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nebraska</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New Mexico</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nevada</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New York</Table.Cell>
                  <Table.Cell>2011</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Ohio</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Oklahoma</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>South Carolina</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Tennessee</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Texas</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Utah</Table.Cell>
                  <Table.Cell>2004</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wisconsin</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wyoming</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Table.Cell>
          <Table.Cell />
          <Table.Cell>
            <Table>
              <Table.Body>
                <Table.Row>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    MVR (DPPA)- Available States
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    By VIN
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alaska</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Colorado</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>DC</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Florida</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Idaho</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Illinois</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Kentucky</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Louisiana</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maine</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Massachusetts</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Michigan</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Minnesota</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Mississippi</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Missouri</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Montana</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nebraska</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nevada</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New Mexico</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New York</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Dakota</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Ohio</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Tennessee</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Texas</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Utah</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wisconsin</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wyoming</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
    <br />
    <br />
    <a className="mvrHref" href="#top">
      Back To Top
    </a>
    <Table>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <Table>
              <Table.Body>
                <Table.Row>
                  <Table.HeaderCell
                    colSpan={2}
                    className={"coverage-table-header"}
                  >
                    MVR Availability
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    State
                  </Table.HeaderCell>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    Last Update
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alaska</Table.Cell>
                  <Table.Cell>2004</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alabama</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Colorado</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Connecticut</Table.Cell>
                  <Table.Cell>2011</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>District of Columbia</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Delaware</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Florida</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Idaho</Table.Cell>
                  <Table.Cell>2004</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Illinois</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Kentucky</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Louisiana</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Massachusetts</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maryland</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maine</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Michigan</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Minnesota</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Missouri</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Mississippi</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Montana</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Carolina</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Dakota</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nebraska</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New Mexico</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nevada</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New York</Table.Cell>
                  <Table.Cell>2011</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Ohio</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Oklahoma</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>South Carolina</Table.Cell>
                  <Table.Cell>Historical</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Tennessee</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Texas</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Utah</Table.Cell>
                  <Table.Cell>2004</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wisconsin</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wyoming</Table.Cell>
                  <Table.Cell>2013</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Table.Cell>
          <Table.Cell />
          <Table.Cell>
            <Table>
              <Table.Body>
                <Table.Row>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    MVR (DPPA)- Available States
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className={"coverage-table-header"}>
                    By Address
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Alaska</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Colorado</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>DC</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Florida</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Idaho</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Illinois</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Kentucky</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Louisiana</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Maine</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Massachusetts</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Michigan</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Minnesota</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Mississippi</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Missouri</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Montana</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nebraska</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Nevada</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New Mexico</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>New York</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>North Dakota</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Ohio</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Tennessee</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Texas</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Utah</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wisconsin</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Wyoming</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  </div>
);

export default vehicleDppaContent;



// WEBPACK FOOTER //
// ./src/components/coveragearea/VehiclesDppa.js